import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function MagicLogin() {
  const [params] = useSearchParams();
  const { magicLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token") || "";
    if (!token) { setError("This sign-in link is incomplete."); return; }
    magicLogin(token)
      .then((u) => {
        const next = params.get("next") || "/account";
        navigate(u.role === "admin" && next === "/account" ? "/admin" : next);
      })
      .catch((e) => setError(errMsg(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-x py-24 max-w-md mx-auto text-center" data-testid="magic-login-page">
      {error ? (
        <>
          <h1 className="font-heading text-2xl font-semibold">Link didn't work</h1>
          <p className="text-sm text-stone-500 mt-2" data-testid="magic-login-error">{error}</p>
          <Link to="/login"><Button className="mt-6 bg-stone-900 hover:bg-brand text-white btn-press" data-testid="magic-login-retry">Back to sign in</Button></Link>
        </>
      ) : (
        <>
          <h1 className="font-heading text-2xl font-semibold">Signing you in…</h1>
          <p className="text-sm text-stone-500 mt-2">One moment while we verify your link.</p>
        </>
      )}
    </div>
  );
}
